export default function DroppedPinIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none" style={{margin: "auto"}}>
            <path d="M12 13.25C13.6569 13.25 15 11.9069 15 10.25C15 8.59315 13.6569 7.25 12 7.25C10.3431 7.25 9 8.59315 9 10.25C9 11.9069 10.3431 13.25 12 13.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 22.25C16 18.25 20 14.6683 20 10.25C20 5.83172 16.4183 2.25 12 2.25C7.58172 2.25 4 5.83172 4 10.25C4 14.6683 8 18.25 12 22.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}